import React, { Component } from 'react';
import { Grid, PanelGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { categoryActions as actions } from '../../../actions';
import '../../../content/css/ThemePackage.css';
import { LoadingIcon } from '../../LoadingIcon';
import AuthService from '../../../services/auth.service';
import LoadingListener from '../../../helpers/loadingListener';
import CategoryPanelGroup from './CategoryPanelGroup';

export const filterType = {
    SHOW_ALL: "SHOW_ALL",
    SHOW_ACTIVE: "SHOW_ACTIVE",
    SHOW_PRIORITY: "SHOW_PRIORITY"
}

class ThemeUserView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: "",
            themePackage: null,
            categories: [],
            categoriesToRender: [],
            filter: filterType.SHOW_ALL
        };

        this.authService = new AuthService();
        this.loadingListener = new LoadingListener([], true);
    }

    componentDidMount() {
        const { type } = this.props.match.params;
        this.setState({ type });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.type !== this.state.type && this.state.type) {
            let themePackage = this.getThemePackageByType(this.state.type);
            if (themePackage === null) this.props.requestThemePackages();
            else this.setState({ themePackage });
        }

        if (prevState.themePackage !== this.state.themePackage) {
            if (this.state.themePackage) this.setState({ categories: this.getCategories(this.state.themePackage) });
        }

        if (prevProps.themePackages !== this.props.themePackages) {
            let themePackage = this.getThemePackageByType(this.state.type);
            if (themePackage) this.setState({ themePackage });
        }

        if (prevState.filter != this.state.filter) {
            this.setState({ categoriesToRender: this.getFilteredConceptGroups() });
        }

        if (prevState.categories != this.state.categories) {
            this.setState({ categoriesToRender: this.getFilteredConceptGroups() });
        }
    }

    getCategoryTheme = (code) => {
        if (!code) return;

        let categoryTheme = this.state.categories.find(x => x.code === code);
        if (categoryTheme === undefined) categoryTheme = this.getCategories(this.state.themePackage).find(x => x.code === code);

        return categoryTheme;
    }

    getCategories = (theme) => {
        if (!theme) return [];
        let categories = theme.categories;
        categories.sort((a, b) => a.name.localeCompare(b.name));
        categories.forEach(x => this.setCategoryPriority(x));
        return categories;
    }

    setCategoryPriority = (category) => {
        if (!category || !this.state.themePackage) return;

        let prioritizedCategoriesForCustomerAgreement = [
            /*### Delivery terms ###*/
            "INCO_CIP", "INCO_CPT", "INCO_CFR", "INCO_CIF", "INCO_DAF", "INCO_DAP", "INCO_DPU", "INCO_DAT", "INCO_DDP",
            "INCO_DDU", "INCO_DEQ", "INCO_DES", "INCO_EXW", "INCO_FAS", "INCO_FCA", "INCO_FOB", "Transfer_Risk",
            /*### Governing law ###*/
            "Dispute_arbitration", "Dispute_court", "G1", "G1_1",
            /*### Liability ###*/
            "Liquidateddamages", "L1", "Liability_damages", "I1", "L3", "Liability_subcontractors", "L2", "Mitigation_loss", "Defects_exclusiveremedy", "Cumulative",
            /*### License rights ###*/
            "License_exclusive", "License_irrevocable", "License_perpetual", "License_royalty_free", "License_sub_licensable", "License - Transferable", "License_worldwide",
            "License_commercialize", "License_copy", "License_derivatives", "License _modify", "License_reproduce", "License_use",
            /*### Other ###*/
            "Audit", "Forecast", "Insurance", "D1_start", "Essence", "Transfer_Title",
            /*### Warranties ###*/
            "W1_COC", "W1_design", "W1_defectinmanufacture", "Warranties", "W1_workmanship", "W1_normaluse", "Exclusivity", "W1_fit", "W1_merchantable", "MFC", "C10",
            "Non-compete", "Non-solicitation", "W1_stateoftheart", "Top_class", "W1", "W2"
        ];

        let prioritizedCategoriesForNDA = [
            /*### Confidentiality ###*/
            "C1", "C2", "C3", "C4", "C6", "C7", "C8", "C9", "Relief",
            /*### Contract details ###*/
            "Amend", "Assignment", "Automatic_renewal", "Surviving_provisions", "Agreement_term", "document_priority", "Entire",
            /*### Governing law ###*/
            "Dispute_arbitration", "Dispute_court", "G1", "G1_1",
            /*### Liability ###*/
            "Liquidateddamages", "L1", "Liability_damages", "I1", "L3", "Liability_subcontractors", "L2", "Mitigation_loss", "Defects_exclusiveremedy", "Cumulative",
            /*### Warranties ###*/
            "W1_COC", "W1_design", "W1_defectinmanufacture", "Warranties", "W1_workmanship", "W1_normaluse", "Exclusivity", "W1_fit", "W1_merchantable", "MFC", "C10",
            "Non-compete", "Non-solicitation", "W1_stateoftheart", "Top_class", "W1", "W2"
        ];

        let prioritizedCategories = [];
        switch (this.state.themePackage.contractType) {
            case 1: prioritizedCategories = prioritizedCategoriesForCustomerAgreement; break;
            case 3: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 4: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 5: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 6: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 7: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 8: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 9: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 10: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 11: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 12: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 13: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 14: prioritizedCategories = prioritizedCategoriesForNDA; break;
            case 15: prioritizedCategories = prioritizedCategoriesForNDA; break;
            default: prioritizedCategories = prioritizedCategoriesForCustomerAgreement; break;
        }

        category.isPriority = prioritizedCategories.includes(category.code);
    }

    getThemePackageByType = (type) => {
        let themePackages = this.props.themePackages.filter(x => x.contractType === type);
        return themePackages.length > 0 ? themePackages[0] : null;
    }

    getTitle = () => {
        return this.state.themePackage ? this.getContractTypeName(this.state.themePackage.contractType) : this.getContractTypeName(this.state.type);
    }

    getName = () => {
        return this.state.themePackage ? this.state.themePackage.name : "";
    }

    getContractTypeName = (type) => {
        switch (type) {
            case "ProcurementAgreement": return "Procurement Agreement";
            case "CustomerAgreement": return "Customer Agreement";
            case "NDA_Customer": return "NDA - receiving information";
            case "NDA_Seller": return "NDA - giving information";
            case "NDA_Mutual": return "NDA - giving & receiving information";
            case "EULA_Seller": return "EULA - Seller";
            case "EULA_Customer": return "EULA - Customer";
            case "DistributionAgreement_Customer": return "Distribution Agreement - Customer";
            case "DistributionAgreement_Seller": return "Distribution Agreement - Seller";
            case "DPA_Controller": return "DPA - Controller";
            case "DPA_Processor": return "DPA - Processor";
            case "LicenseAgreement_Customer": return "License Agreement - Customer";
            case "LicenseAgreement_Seller": return "License Agreement - Seller";
            case "SourcingOfGoods_Customer": return "Sourcing of Goods - Customer";
            case "SourcingOfGoods_Seller": return "Sourcing of Goods - Seller";
            case "Services_Customer": return "Online Services - Customer";
            case "Services_Seller": return "Online Services - Seller";
            case "PersonalServices_Customer": return "Personal Services - Customer";
            case "PersonalServices_Seller": return "Personal Services - Seller";
            case "CarrierAgreement": return "Carrier Agreement";
            case "BrokerAgreement": return "Broker Agreement";
            case "Unknown": return "Unknown";
            default: return type;
        }
    }

    handleEditCategory = (categoryTheme) => {
        this.props.addOrUpdateCategoryTheme(this.state.themePackage.id, categoryTheme);
    }

    handleFilterChange = (e) => {
        this.setState({ filter: e });
    }

    getFilterLabel = () => {
        switch (this.state.filter) {
            case filterType.SHOW_ALL: return "Show all";
            case filterType.SHOW_ACTIVE: return "Show active";
            case filterType.SHOW_PRIORITY: return "Show priority";
        }
    }

    getFilteredConcepts = () => {
        switch (this.state.filter) {
            case filterType.SHOW_ALL: return this.state.categories;
            case filterType.SHOW_ACTIVE: return this.state.categories.filter(x => x.isActive);
            case filterType.SHOW_PRIORITY: return this.state.categories.filter(x => x.isPriority);
        }
    }

    getFilteredConceptGroups = () => {
        let groups = {};
        let otherGroup = [];
        let categories = this.getFilteredConcepts();
        categories.forEach(x => {
            if (x.group == "Other") otherGroup.push(x);
            else if (groups[x.group]) groups[x.group].push(x);
            else groups[x.group] = [x];
        });

        let orderedGroups = Object.entries(groups);
        orderedGroups.sort((a, b) => a[0].localeCompare(b[0]));
        if (otherGroup.length > 0)
            orderedGroups.push(['Other', otherGroup]);
        return orderedGroups;
    }

    isAllowedToEdit = () => {
        if (!this.state.themePackage)
            return false;

        if (this.authService.isAdmin())
            return true;

        let themeIsUsers = this.state.themePackage.organizationIds.includes(this.authService.getEmailDomain());
        return this.authService.canEditThemes() && themeIsUsers;
    }

    renderGroups = () => {
        let isAllowedToEdit = this.isAllowedToEdit();

        return this.state.categoriesToRender.map(([key, value]) => (
            <CategoryPanelGroup
                header={key}
                categories={value}
                getCategoryTheme={this.getCategoryTheme}
                isAllowedToEdit={isAllowedToEdit}
                onEdit={this.handleEditCategory}
            />
        ));
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let isAdmin = this.authService.isAdmin();

        return (
            <div className="theme-user-view">
                <div className="title">
                    <h2>{this.getTitle()}</h2>
                    {isAdmin && <span>{this.getName()}</span>}
                    <span>Review the concepts active for this theme.</span>
                </div>
                <Grid fluid>
                    {!this.state.themePackage && !isLoading && <p>No theme found!</p>}
                    {isAdmin &&
                        <div className="filter-dropdown">
                            <DropdownButton title={this.getFilterLabel()} id="filter-dropdown" onSelect={this.handleFilterChange}>
                                <MenuItem eventKey={filterType.SHOW_ALL}>Show all</MenuItem>
                                <MenuItem eventKey={filterType.SHOW_ACTIVE}>Show active</MenuItem>
                                <MenuItem eventKey={filterType.SHOW_PRIORITY}>Show priority</MenuItem>
                            </DropdownButton>
                        </div>
                    }
                    <hr />
                    <PanelGroup>
                        {this.renderGroups()}
                    </PanelGroup>
                    {isLoading && <LoadingIcon />}
                </Grid>
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(ThemeUserView);


// WEBPACK FOOTER //
// ./src/components/CategoryView/UserView/ThemeUserView.js